/* eslint-disable @typescript-eslint/no-unused-vars */
import * as d3 from 'd3'

export const centerMap = (name: any, currentZoom = 0.3) => {
  const g = d3.select('#map').select('svg').select('g')

  const svgBox = (document
    .getElementById('map') as any)
    .getBoundingClientRect()

  const map: any = document.getElementById('map')
  const popupBox = (document.getElementById('popup') as any).getBoundingClientRect()
  if (popupBox.width === 0 && popupBox.height === 0) {
    positionPopup([
      map.offsetLeft + svgBox.width / 2 - 219 + 107,
      map.offsetTop + svgBox.height / 2 - 205 + 90,
    ])
  } else {
    positionPopup([
      map.offsetLeft + svgBox.width / 2 - 189 + popupBox.width / 2,
      map.offsetTop + svgBox.height / 2 - 178 + popupBox.height / 2,
    ])
  }

  // positionPopup([
  //   map.offsetLeft + svgBox.width / 2 - 112 + popupBox.width / 2,
  //   map.offsetTop + svgBox.height / 2 - 117 + popupBox.height / 2,
  // ])

  g.transition()
    .duration(150)
    .attr(
      'transform',
      (d: any) =>
        `translate(${(d.x =
          svgBox.width / 2 -
          (document.getElementById(name) as any).getBBox().x * currentZoom)} ${(d.y =
            svgBox.height / 2 -
            (document.getElementById(name) as any).getBBox().y *
            currentZoom)}) scale(${currentZoom})`
    )
}

export const positionPopup = (coords: any, dragged = false) => {
  const popup: any = document.getElementById('popup')
  if (dragged) {
    popup.style.left = parseFloat(popup.style.left) + coords[0] + 'px'
    popup.style.top = parseFloat(popup.style.top) + coords[1] + 'px'
  } else {
    const popup: any = document.getElementById('popup')
    const popupBox = popup.getBoundingClientRect()
    popup.style.position = 'absolute'
    // popup.style.left = coords[0] - popupBox.width / 2 + 'px'
    // popup.style.top = coords[1] - popupBox.height / 2 + 'px'
    popup.style.left = coords[0] + 125 + 'px'
    popup.style.top = coords[1] + 95.5 + 'px'
  }
}

export const highlightPath = (path: any, data: any) => {
  /*const g = d3.select('#map').select('svg').select('g')

  const svgBox = document
    .getElementById('map')
    .getElementsByTagName('svg')[0]
    .getBoundingClientRect()
	
  const fromNodeX = document.getElementById(path[0].split("-")[0]+"fromFlag").parentElement.getAttribute("x") || 0
  const fromNodeY = document.getElementById(path[0].split("-")[0]+"fromFlag").parentElement.getAttribute("y") || 0

  const map = document.getElementById('map')
  g.transition()
    .duration(150)
    .attr(
      'transform',
      (d) =>
        `translate(${svgBox.width/2 - fromNodeX},${svgBox.height/2 - fromNodeY})`
    )*/
  const reversed = path.map((p: any) => p.split('-').reverse().join('-'))
  const interchanges = path.flatMap((p: any) => p.split('-'))

  Array.from(document.querySelectorAll('.lines line')).forEach((line: any) => {
    // if (data?.localities?.length > 0 && (data?.localities[0]?.source_stn_localities?.length > 0 || data?.localities[0]?.destination_stn_localities?.length > 0)) {
    //   let st: any[] = [];
    //   if (data?.localities[0]?.source_stn_localities?.length > 0 && !data?.localities[0]?.destination_stn_localities) {
    //     st?.push(`fromlt-${data?.localities[0]?.source_stn_localities[0]?.nearest_metro_station?.code}`)
    //   }
    //   if (data?.localities[0]?.destination_stn_localities?.length > 0 && !data?.localities[0]?.source_stn_localities) {
    //     st?.push(`${data?.localities[0]?.destination_stn_localities[0]?.nearest_metro_station?.code}-tolt`)
    //   }
    //   if (data?.localities[0]?.source_stn_localities?.length > 0 && data?.localities[0]?.destination_stn_localities?.length > 0) {
    //     st?.push(`fromlt-${data?.localities[0]?.source_stn_localities[0]?.nearest_metro_station?.code}`)
    //     st?.push(`${data?.localities[0]?.destination_stn_localities[0]?.nearest_metro_station?.code}-tolt`)
    //   }

    //   if (
    //     path.includes(line.__data__.name) ||
    //     reversed.includes(line.__data__.name) ||
    //     st.includes(line.__data__.name)
    //   ) {
    //     line.style.stroke = "#0000ff5c"
    //     line.style.strokeOpacity = '1'
    //     line.style.animation = 'flickerAnimation 0.7s linear infinite'
    //   } else if(line.__data__.name === "tolt-fromlt") {
    //     line.style.stroke = line.__data__.color
    //     line.style.strokeOpacity = '1'
    //     line.style.animation = 'flickerAnimation 0.7s linear infinite'
    //   } else {
    //     line.style.stroke = '#1AD5FF'
    //     line.style.strokeOpacity = '1'
    //     line.style.animation = 'none'
    //   }
    // } else {
      if (
        path.includes(line.__data__.name) ||
        reversed.includes(line.__data__.name)
      ) {
        line.style.stroke = line.__data__.color
        line.style.strokeOpacity = '1'
        line.style.animation = 'flickerAnimation 0.7s linear infinite'
      } else {
        line.style.stroke = '#bdbdbd'
        line.style.strokeOpacity = '1'
        line.style.animation = 'none'
      }
    // }
  })
  Array.from(
    document.querySelectorAll(
      '.interchanges rect, .transferStations path, .stations path'
    )
  ).forEach((interchange: any) => {
    if (interchanges.includes(interchange.__data__.name)) {
      interchange.style.stroke = "#fff"
      interchange.style.fill = "#0CB1DA"
    } else {
      interchange.style.stroke = '#1AD5FF'
       interchange.style.fill = "#DDDDDD"
    }

  })
}

export const clearMap = () => {
  //window.localStorage.setItem('journeyPlan', '{}')
  Array.from(document.querySelectorAll('.toFlags div')).forEach((flag: any) => {
    flag.style.visibility = 'hidden'
  })

  Array.from(document.querySelectorAll('.fromFlags div')).forEach((flag: any) => {
    flag.style.visibility = 'hidden'
  })

  Array.from(document.querySelectorAll('.lines line')).forEach((line: any) => {
    line.style.stroke = line.__data__.color
    line.style.animation = 'none'
  })
  Array.from(
    document.querySelectorAll(
      '.interchanges rect, .transferStations path, .stations path'
    )
  ).forEach((interchange: any) => {
    interchange.style.stroke = interchange.__data__.marker[0].color
  })
}
